/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { ChargeType } from 'app/shared/model/enumerations/charge-type.model';
import { InwardChargeType } from 'app/shared/model/enumerations/inward-charge-type.model';
import { HikeType } from 'app/shared/model/enumerations/hike-type.model';
import { createEntity, getEntity, reset, updateEntity } from './op-charge.reducer';

export const OPChargeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const oPChargeEntity = useAppSelector(state => state.oPCharge.entity);
  const loading = useAppSelector(state => state.oPCharge.loading);
  const updating = useAppSelector(state => state.oPCharge.updating);
  const updateSuccess = useAppSelector(state => state.oPCharge.updateSuccess);
  const chargeTypeValues = Object.keys(ChargeType);
  const inwardChargeTypeValues = Object.keys(InwardChargeType);
  const hikeTypeValues = Object.keys(HikeType);

  const handleClose = () => {
    navigate(`/op-charge${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
    dispatch(getPaymentSchemes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.charge !== undefined && typeof values.charge !== 'number') {
      values.charge = Number(values.charge);
    }
    if (values.emergencyHike !== undefined && typeof values.emergencyHike !== 'number') {
      values.emergencyHike = Number(values.emergencyHike);
    }
    if (values.hishRiskHike !== undefined && typeof values.hishRiskHike !== 'number') {
      values.hishRiskHike = Number(values.hishRiskHike);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...oPChargeEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          chargeType: 'HOURLY',
          relatedTo: 'AdmissionFee',
          emergencyHikeType: 'PERCENTAGE',
          hishRiskHikeType: 'PERCENTAGE',
          ...oPChargeEntity,
          hospital: oPChargeEntity?.hospital?.id,
          scheme: oPChargeEntity?.scheme?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.oPCharge.home.createOrEditLabel" data-cy="OPChargeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.oPCharge.home.createOrEditLabel">Create or edit a OPCharge</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="op-charge-id"
                  label={translate('tinyMedicRestApp.oPCharge.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.name')}
                id="op-charge-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.description')}
                id="op-charge-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.charge')}
                id="op-charge-charge"
                name="charge"
                data-cy="charge"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.chargeType')}
                id="op-charge-chargeType"
                name="chargeType"
                data-cy="chargeType"
                type="select"
              >
                {chargeTypeValues.map(chargeType => (
                  <option value={chargeType} key={chargeType}>
                    {translate(`tinyMedicRestApp.ChargeType.${chargeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.relatedTo')}
                id="op-charge-relatedTo"
                name="relatedTo"
                data-cy="relatedTo"
                type="select"
              >
                {inwardChargeTypeValues.map(inwardChargeType => (
                  <option value={inwardChargeType} key={inwardChargeType}>
                    {translate(`tinyMedicRestApp.InwardChargeType.${inwardChargeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.tax')}
                id="op-charge-tax"
                name="tax"
                data-cy="tax"
                type="text"
                validate={{
                  maxLength: { value: 10, message: translate('entity.validation.maxlength', { max: 10 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.emergencyHike')}
                id="op-charge-emergencyHike"
                name="emergencyHike"
                data-cy="emergencyHike"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.hishRiskHike')}
                id="op-charge-hishRiskHike"
                name="hishRiskHike"
                data-cy="hishRiskHike"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.emergencyHikeType')}
                id="op-charge-emergencyHikeType"
                name="emergencyHikeType"
                data-cy="emergencyHikeType"
                type="select"
              >
                {hikeTypeValues.map(hikeType => (
                  <option value={hikeType} key={hikeType}>
                    {translate(`tinyMedicRestApp.HikeType.${hikeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.hishRiskHikeType')}
                id="op-charge-hishRiskHikeType"
                name="hishRiskHikeType"
                data-cy="hishRiskHikeType"
                type="select"
              >
                {hikeTypeValues.map(hikeType => (
                  <option value={hikeType} key={hikeType}>
                    {translate(`tinyMedicRestApp.HikeType.${hikeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.active')}
                id="op-charge-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.microSec')}
                id="op-charge-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.timestampEntry')}
                id="op-charge-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.lastUpdated')}
                id="op-charge-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.oPCharge.cursor')}
                id="op-charge-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                id="op-charge-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.oPCharge.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="op-charge-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.oPCharge.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/op-charge" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OPChargeUpdate;
